// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__qxvWv","head":"ProcedureTableInfo_head__raUl0"};